import {useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import {filterBasicTypes} from '@adv-mt/mt-filter-basic'
import FilterWrapperBasic, {filterWrapperBasicTypes} from '@adv-mt/mt-filter-wrapper-basic'

import {getInitialValue} from '../utils.js'

const filterName = 'fuelType'

export const FuelTypesFilter = ({options, onChange, value}) => {
  const [selectedFuelTypeOption, setSelectedFuelTypeOption] = useState(getInitialValue({options, value}))

  useEffect(() => {
    onChange(selectedFuelTypeOption)
  }, [selectedFuelTypeOption, onChange])

  const _handleOnChange = item => {
    const {value: newFuelTypeIds} = item
    setSelectedFuelTypeOption(newFuelTypeIds)
  }

  const filters = [
    {
      name: filterName,
      options,
      type: filterBasicTypes.MULTI_SELECTION_OUTLINED
    }
  ]

  return (
    <FilterWrapperBasic
      filters={filters}
      group={`${filterName}Group`}
      legend="Combustible"
      onChange={_handleOnChange}
      value={{[filterName]: selectedFuelTypeOption}}
      wrapper={filterWrapperBasicTypes.NONE}
    />
  )
}

FuelTypesFilter.propTypes = {
  value: PropTypes.object,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
}
